import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol } from 'mdbreact';
import BasicLabel from '../../components/SharedComponents/BasicLabel/BasicLabel';
import DateField from "../../components/SharedComponents/DateField/DateField";
import ReportButton from './ReportButton';
import { s2ab, genReportName } from '../../Common/Helper';
import { withUserContext } from '../../../contexts/UserContext';
import SelectField from '../SharedComponents/SelectField/SelectField';
import CasterService from "../../../services/service";
import * as Constants from "../../../constants/constants";
import { downloadUrl, extractFilenameFromUrl } from "../../Common/Helper";
import SearchSelectField from '../SharedComponents/SearchSelectField';
import './Station12.scss';
import MessageModal from '../SharedComponents/MessageModal';

class Station12 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportDetails: [],
            postInitiated: false,
            station12Modal: false,
            pdfRes: null
        }
    }
    onChangeCallBack = (field, val) => {
        this.setState({
            [field]: val,
            postInitiated: false
        });
    }

    onClickGenratePdf() {
        this.setState({ postInitiated: true })

        let searchPayload = {
            show_id: this.props?.reportDetails.show_id.value,
            show_season_id: this.props?.reportDetails.show_season_id,
            episode_id: this.props?.reportDetails.episode_id,
            contract_start_date: this.props?.reportDetails?.contract_start_date,
            contract_end_date: this.props?.reportDetails?.contract_end_date,
        };

        Object.keys(searchPayload).map((obj) => {
            if (searchPayload[obj] === undefined) {
                searchPayload[obj] = null;
            }
        });
        let encryptTedStr = btoa(JSON.stringify(searchPayload));

        let load = {
            payload: "casterAnimationGenerateReport",
            reportName: "rptStation12",
            fileName: "rptStation12",
            searchJson: encryptTedStr,
            showHtml: 0,
            encryptionType: 1
        };
        CasterService.getDataWS(load).then(
            (webSocketConn) =>
            (webSocketConn.onmessage = (e) => {
                let response = JSON.parse(e.data);
                if (response?.statusCode == 200 && response?.body?.message) {
                    this.setState({ station12Modal: true, pdfRes: response.body.message, postInitiated: false })
                } else if (response?.statusCode == 200 && response?.body) {
                    this.setState({ postInitiated: false })
                    const filename = extractFilenameFromUrl(response?.body);
                    let decodedFile = decodeURIComponent(filename)
                    downloadUrl(response?.body, decodedFile, "Station 12");
                }
            })
        );
    }

    render() {
        console.log(this.props?.reportDetails);
        return (
            <div>
                <MDBContainer className="reportContainer Worksheet InterviewList1 stationContainer">
                    <span className="header" style={{ fontSize: "10px" }}>
                        The file will generate in your browser as PDF.
                    </span>
                    <MDBRow>
                        <MDBCol md={8}>
                            <SearchSelectField
                                id={"show"}
                                label={"Select Show"}
                                defaultMenuText={"-"}
                                options={this.props?.showOption}
                                valueSelected={(e, value) =>
                                    this.props.handleGeneralEdit("show_id", value)
                                }
                                searchSelect={true}
                                searchText={(e) => this.props?.getShow("SHOW", e.target.value)}
                                detail_selected={this.props?.reportDetails?.show_id}
                            />
                        </MDBCol>
                    </MDBRow>
                    <MDBRow>
                        <MDBCol md={8}>
                            <SelectField
                                id={"season"}
                                value={this.props?.reportDetails?.show_season_id}
                                label={"Select season"}
                                defaultMenuText={"-"}
                                options={this.props?.seasonOption}
                                onChange={(e) =>
                                    this.props.handleGeneralEdit("show_season_id", e.target.value)
                                }
                            />
                        </MDBCol>
                    </MDBRow>
                    <MDBRow>
                        <MDBCol md={8}>
                            <SelectField
                                id={"episode"}
                                value={this.props?.reportDetails?.episode_id}
                                label={"Select episode"}
                                defaultMenuText={"-"}
                                options={this.props?.episodeOption}
                                onChange={(e) =>
                                    this.props.handleGeneralEdit("episode_id", e.target.value)
                                }
                            />
                        </MDBCol>
                    </MDBRow>
                    <MDBRow>
                        <MDBRow>
                            <BasicLabel text={"Date Range"} isMandatory={true} />
                        </MDBRow>
                        <MDBCol md={6}>
                            <DateField
                                id="selectStartDate"
                                isMandatory={true}
                                showMandatory={this.state?.reportDetails.postInitiated || false}
                                value={this.props?.reportDetails.contract_start_date || ""}
                                label={""}
                                onChange={(e) => this.props.handleGeneralEdit('contract_start_date', e.target.value ? e.target.value : null)}
                            />
                        </MDBCol>
                        <MDBCol md={6} style={{ marginLeft: "-26px" }}>
                            <DateField
                                id="selectEndDate"
                                isMandatory={true}
                                showMandatory={this.state?.reportDetails.postInitiated || false}
                                value={this.props?.reportDetails.contract_end_date || ""}
                                label={""}
                                showErrorBorder={(this.props?.reportDetails?.contract_end_date &&
                                    (new Date(this.props?.reportDetails?.contract_end_date) < new Date(this.props?.reportDetails?.contract_start_date))) || false}
                                onChange={(e) => this.props.handleGeneralEdit('contract_end_date', e.target.value ? e.target.value : null)}
                            />
                        </MDBCol>
                    </MDBRow>
                    <ReportButton
                        onClickGenratePdf={this.onClickGenratePdf.bind(this)}
                        handleClose={this.props?.handleClose}
                        postInitiated={this.state.postInitiated}
                    />
                </MDBContainer>
                {
                    this.state.station12Modal &&
                    <MessageModal
                        title={"PDF Download Failed"}
                        open={this.state.station12Modal}
                        message={
                            this.state.pdfRes
                        }
                        primaryButtonText={""}
                        secondaryButtonText={"Cancel"}
                        handleClose={(e) => this.setState({ station12Modal: false, postInitiated: false })}
                    />
                }
            </div>
        )
    }
}

export default withUserContext(Station12)
